import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Categories.css';
import { API_BASE, getAssetUrl } from '../config/api';
import LoadingSpinner from './LoadingSpinner';

const Categories = ({ onCategorySelect }) => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch(`${API_BASE}/categories?isActive=true`);
      const data = await response.json();
      setCategories(data.data || []);
    } catch (error) {
      console.error('Error fetching categories:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCategoryClick = (category) => {
    // Map category names to their database category values and subcategories
    const categoryMapping = {
      "BAG'S COLLECTION": {
        category: "Bags & Luggage",
        subcategories: null,
        displayName: "Bags & Luggage"
      },
      "MEN'S ACCESSORIES": {
        category: "Men",
        subcategories: ["Watches", "Wallets", "Belts", "Sunglasses", "Caps & Hats", "Socks"],
        displayName: "Men's Accessories"
      },
      "MEN'S SHOES": {
        category: "Men",
        subcategories: ["Casual Shoes", "Formal Shoes", "Sneakers", "Sandals & Slides", "Boots"],
        displayName: "Men's Shoes"
      },
      "MEN'S CLOTHING": {
        category: "Men",
        subcategories: ["T-Shirts & Polos", "Shirts", "Jeans", "Trousers & Shorts", "Jackets & Coats", "Sweatshirts & Hoodies", "Innerwear & Sleepwear"],
        displayName: "Men's Clothing"
      },
      "WOMEN CLOTHING": {
        category: "Women",
        subcategories: ["Tops & T-Shirts", "Dresses", "Jeans & Trousers", "Skirts & Shorts", "Sweaters & Jackets", "Lingerie & Sleepwear"],
        displayName: "Women Clothing"
      },
      "WOMEN'S ACCESSORIES": {
        category: "Women",
        subcategories: ["Jewelry", "Bags & Purses", "Watches", "Sunglasses", "Scarves & Hats", "Hair Accessories"],
        displayName: "Women's Accessories"
      },
      "WOMEN'S FOOTWEAR": {
        category: "Women",
        subcategories: ["Heels", "Flats", "Sandals", "Sneakers", "Boots"],
        displayName: "Women's Footwear"
      },
      "NEW ARRIVAL": {
        showcaseSection: "new-arrivals",
        displayName: "New Arrivals"
      },
      "WOMEN": {
        category: "Women",
        subcategories: null,
        displayName: "Women"
      },
      "MEN": {
        category: "Men",
        subcategories: null,
        displayName: "Men"
      },
      "KIDS": {
        category: "Kids",
        subcategories: null,
        displayName: "Kids"
      },
      "BEAUTY & PERSONAL CARE": {
        category: "Beauty & Personal Care",
        subcategories: null,
        displayName: "Beauty & Personal Care"
      },
      "ELECTRONICS & GADGETS": {
        category: "Electronics & Gadgets",
        subcategories: null,
        displayName: "Electronics & Gadgets"
      },
      "HOME & LIVING": {
        category: "Home & Living",
        subcategories: null,
        displayName: "Home & Living"
      },
      "SPORTS & OUTDOORS": {
        category: "Sports & Outdoors",
        subcategories: null,
        displayName: "Sports & Outdoors"
      },
      "UNISEX": {
        category: "Unisex",
        subcategories: null,
        displayName: "Unisex"
      }
    };
    
    // Get the mapping for this category
    const mapping = categoryMapping[category.name.toUpperCase()] || { category: category.name, subcategories: null, displayName: category.name };
    
    // Build URL - check if it's a showcase section
    let url;
    if (mapping.showcaseSection) {
      url = `/products?showcaseSection=${mapping.showcaseSection}`;
    } else {
      url = `/products?category=${encodeURIComponent(mapping.category)}&categoryName=${encodeURIComponent(mapping.displayName)}`;
      
      if (mapping.subcategories) {
        url += `&subcategories=${encodeURIComponent(mapping.subcategories.join(','))}`;
      }
    }
    
    // Navigate to products page
    navigate(url);
    // Scroll to top after navigation
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
  };

  if (loading) {
    return (
      <section className="featured-categories">
        <div className="container">
          <h2 className="section-title">Shop by Category</h2>
          <LoadingSpinner />
        </div>
      </section>
    );
  }

  return (
    <section className="featured-categories">
      <div className="container">
        <h2 className="section-title">Shop by Category</h2>
        <div className="category-grid">
          {categories.map((category) => (
            <div
              key={category._id}
              className="category-card"
              onClick={() => handleCategoryClick(category)}
            >
              <div className="category-image" style={{ 
                backgroundImage: category.image ? `url(${getAssetUrl(category.image)})` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
              }}>
                <span className="category-label">{category.name}</span>
              </div>
              <h3 className="category-name">{category.name}</h3>
              <a href="#" className="category-link" onClick={(e) => e.preventDefault()}>
                Discover
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;
